module.exports = __webpack_public_path__ + "static/media/psikolog-cepte.70369b96.png";